import React from "react";
import styled from "styled-components";

const Path = styled.path`
  stroke: ${props => props.theme.icon};
  fill: ${props => (props.selected ? props.theme.icon : "none")};
`;

const ServiceCentersIcon = ({ selected }) => {
  if (window.innerWidth > 1800) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21.732"
        height="32.316"
        viewBox="0 0 21.732 32.316"
      >
        <Path
          selected={selected}
          d="M9.866,0A10.032,10.032,0,0,0,0,10.192C0,15.815,9.866,29.6,9.866,29.6s9.866-13.783,9.866-19.406A10.032,10.032,0,0,0,9.866,0Z"
          transform="translate(1 1)"
          strokeWidth="2"
        />
      </svg>
    );
  } else {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12.693"
        height="18.898"
        viewBox="0 0 12.693 18.898"
      >
        <Path
          selected={selected}
          d="M5.846,0A5.944,5.944,0,0,0,0,6.039c0,3.332,5.846,11.5,5.846,11.5s5.846-8.167,5.846-11.5A5.944,5.944,0,0,0,5.846,0Z"
          transform="translate(.5 .5)"
        />
      </svg>
    );
  }
};

export default ServiceCentersIcon;
